import { BusinessModuleType } from './business-module-type.js';

export enum DashboardType {
  Calendar = 'calendar',
  Ticket = 'ticket',
  TicketTracker = 'ticket-tracker',
  Pool = 'pool',
  PointOfInterest = 'poi',
  Promoter = 'promoter',
  Gym = 'gym',
  TicketBooking = 'ticket-booking',
}

export function getDashboardFromBusinessModule(moduleType: BusinessModuleType): DashboardType {
  switch(moduleType) {
    case BusinessModuleType.Legacy:
    case BusinessModuleType.Calendar:
      return DashboardType.Calendar;
    case BusinessModuleType.Ticket:
      return DashboardType.Ticket;
    case BusinessModuleType.Pool:
      return DashboardType.Pool;
    case BusinessModuleType.PointOfInterest:
      return DashboardType.PointOfInterest;
    case BusinessModuleType.Gym:
      return DashboardType.Gym;
    case BusinessModuleType.TicketBooking:
      return DashboardType.TicketBooking;
  }
}
